import type {
  GradeElementaryMiddle,
  GradeHigh,
  Revision,
  SchoolType,
  Semester,
} from '@mathflat/domain/@entities/SchoolSystem/schema'

export const getGradeSubjectSemesterRevisionToKor = ({
  grade,
  semester,
  schoolType,
  subject,
  revision,
}: {
  grade: GradeElementaryMiddle | null
  semester: Semester
  schoolType: SchoolType
  subject: GradeHigh | null
  revision: Revision
}) => {
  const revisionText = revision === 'CURRICULUM_22' ? '(22개정)' : ''

  switch (schoolType) {
    case 'ELEMENTARY':
      return `초${grade ?? ''}-${semester}${revisionText}`

    case 'MIDDLE':
      return `중${grade ?? ''}-${semester}${revisionText}`

    case 'HIGH':
      return `${subject ?? ''}-${semester}${revisionText}`

    default:
      return `-${semester}${revisionText}`
  }
}
